import { render, staticRenderFns } from "./SoccerFilters.vue?vue&type=template&id=2623e9d3&"
import script from "./SoccerFilters.vue?vue&type=script&lang=js&"
export * from "./SoccerFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports